// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import { getBaseUrl } from "../configVariables";
import { postChannelInfo } from "../apis/messageListApi";

export interface IConfigState {
  url: string;
}

class Configuration extends React.Component<{}, IConfigState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      url: getBaseUrl() + "/messages?locale={locale}",
    };
  }

  public componentDidMount() {
    microsoftTeams.initialize();

    microsoftTeams.getContext((context) => {
      if (context.groupId) {
        console.log(context.groupId);
        postChannelInfo(context.groupId).then((x) => {
          microsoftTeams.settings.registerOnSaveHandler((saveEvent) => {
            microsoftTeams.settings.setSettings({
              entityId: "Akari_Read_And_Sign",
              contentUrl: this.state.url,
              suggestedDisplayName: "Read & Sign",
            });
            saveEvent.notifySuccess();
          });
        });
      }
    });

    microsoftTeams.settings.setValidityState(true);
  }

  public render(): JSX.Element {
    return (
      <div className="configContainer">
        <h3>
          Welcome to Akari Read And Sign, Please click Save to get started.
        </h3>
      </div>
    );
  }
}

export default Configuration;
